// Close hamburger menu after click on menu items
$(document).ready(function () {
  $(".menu-drawer-container .list-menu__item").on("click", function () {
    $(".menu-drawer-container").removeAttr("open");
    $(".menu-drawer-container summary").attr("aria-expanded", "false");
    $(".menu-drawer-container").removeClass("menu-opening");
  });
});

// Opening one accordion and close all other accordions
$(document).ready(function () {
  $(".accordion details").on("click", function () {
    $(this).attr("open");
    $(this).parent(".accordion").siblings().find("details").removeAttr("open");
  });
});

// Smooth Scrolling JS start
jQuery(document).ready(function ($) {
  let scrollOffset = 60;
  if (window.location.hash) {
    // smooth scroll to the anchor id
    jQuery("html,body").animate({
      scrollTop: jQuery(window.location.hash).offset().top - scrollOffset,
    });
  } else {
    setTimeout(function () {
      scroll(0, 0);
    }, 1);
  }
  jQuery("a[href*=\\#]:not([href$=\\#])").on("click", function (evt) {
    evt.preventDefault();
    var url = jQuery(this).attr("href");
    var id = url.substring(url.lastIndexOf("#"));
    if (jQuery(id).length > 0) {
      jQuery("html, body").animate(
        {
          scrollTop: jQuery(id).offset().top - scrollOffset,
        },
        500
      );
    } else {
      window.location.href = url;
    }
  });
});
// Smooth Scrolling JS end
